import { FC, useState } from 'react';
import { PaginationUpdateEvent } from 'ui/paginationFooter';

import {
  ReferencesPaginationContext,
  ReferencesPaginationState,
} from './ReferencesPaginationContext';

export const ReferencesPaginationContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);

  const handlePaginationChange = ({ page, pageSize }: PaginationUpdateEvent): void => {
    setCurrentPage(page);
    setLimit(pageSize);
  };

  const context: ReferencesPaginationState = {
    currentPage,
    limit,
    handlePaginationChange,
  };

  return (
    <ReferencesPaginationContext.Provider value={context}>
      {children}
    </ReferencesPaginationContext.Provider>
  );
};
